import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { getRouteStackPath } from '@portal/config/routes';
import PanelContent from '~/components/PanelContent/PanelContent';

import { translate } from '@portal/services/i18n';
import NotFound from '@portal/pages/NotFound/NotFound';
import { TransactionType } from '@portal/models/enumerators';
import MyLimits from './MyLimits/MyLimits';
import Limits from './Limits/Limits';

const LimitsNavigationStack = () => {
  return (
    <Switch>
      <Route exact path={getRouteStackPath('LIMITS', 'LIMITS_PAGE')}>
        <PanelContent pageTitle={translate('PAGES.MY_ACCOUNT.TABS.MY_LIMITS')}>
          <MyLimits />
        </PanelContent>
      </Route>

      <Route exact path={getRouteStackPath('LIMITS', 'LIMITS_PIX')}>
        <PanelContent pageTitle={translate('PAGES.MY_ACCOUNT.TABS.LIMITS_PIX')}>
          <Limits transactionType={TransactionType.PIX} />
        </PanelContent>
      </Route>

      <Route exact path={getRouteStackPath('LIMITS', 'LIMITS_BILLET')}>
        <PanelContent
          pageTitle={translate('PAGES.MY_ACCOUNT.TABS.LIMITS_BILLET')}
        >
          <Limits transactionType={TransactionType.BILLET} />
        </PanelContent>
      </Route>

      <Route exact path={getRouteStackPath('LIMITS', 'LIMITS_TED')}>
        <PanelContent pageTitle={translate('PAGES.MY_ACCOUNT.TABS.LIMITS_TED')}>
          <Limits transactionType={TransactionType.TED} />
        </PanelContent>
      </Route>

      <Route exact path={getRouteStackPath('LIMITS', 'LIMITS_P2P')}>
        <PanelContent pageTitle={translate('PAGES.MY_ACCOUNT.TABS.LIMITS_P2P')}>
          <Limits transactionType={TransactionType.P2P} />
        </PanelContent>
      </Route>

      <Route exact path={getRouteStackPath('LIMITS', 'LIMITS_API_GATEWAY_PIX')}>
        <PanelContent
          pageTitle={translate('PAGES.MY_ACCOUNT.TABS.LIMITS_API_GATEWAY_PIX')}
        >
          <Limits transactionType={TransactionType.API_GATEWAY_PIX} />
        </PanelContent>
      </Route>
      <Route>
        <NotFound />
      </Route>
    </Switch>
  );
};

export default LimitsNavigationStack;
